import { Box, Button, styled } from '@mui/material';

export const IdCardAddLinkButtonStyled = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  border: `0.2rem dashed ${theme.palette.primaryDark.main}`,
  backgroundColor: theme.palette.grey[200],
  color: theme.palette.grey[400],
  padding: 0,
  minHeight: '18rem',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const IdCardAddLinkButtonContentWrapperStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});
